(() => {
  const ROOT_SELECTOR = '[data-hk-premium-collection]';

  const setActivePanel = (section, tab) => {
    const panelId = tab.dataset.hkPremiumTab;

    section.querySelectorAll('[data-hk-premium-tab]').forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    section.querySelectorAll('[data-hk-premium-panel]').forEach((panel) => {
      const isActive = panel.dataset.hkPremiumPanel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  const openCartDrawer = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!trigger || trigger.getAttribute('aria-expanded') === 'true') return;
    trigger.click();
  };

  const initSection = (section) => {
    if (section.dataset.hkPremiumReady === 'true') return;
    section.dataset.hkPremiumReady = 'true';

    const tabs = [...section.querySelectorAll('[data-hk-premium-tab]')];

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActivePanel(section, tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        setActivePanel(section, tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });

    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    if (requestedProduct) {
      const requestedTab = tabs.find((tab) => tab.dataset.hkPremiumProductHandle === requestedProduct);
      if (requestedTab) {
        setActivePanel(section, requestedTab);
        window.requestAnimationFrame(() => {
          const tabList = requestedTab.parentElement;
          if (!tabList || tabList.scrollWidth <= tabList.clientWidth) return;
          const centeredLeft = requestedTab.offsetLeft - (tabList.clientWidth - requestedTab.offsetWidth) / 2;
          tabList.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'auto' });
        });
      }
    }

    section.addEventListener('shopify:cart:lines-update', (event) => {
      const sourceCard = event.target instanceof Element
        ? event.target.closest('.hkpv-card')
        : null;
      if (!sourceCard || !section.contains(sourceCard)) return;
      window.setTimeout(openCartDrawer, 120);
    });
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initSection(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initSection);
  };

  initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest(ROOT_SELECTOR);
    const tab = section?.querySelector(`[data-hk-premium-block-id="${event.detail.blockId}"]`);
    if (section && tab) setActivePanel(section, tab);
  });
})();
